import { TechnicalError } from '../../common/errors';
import Result from '../../common/result';
import { Token, TokenResult } from '../../services/common/token';

export default class NullToken implements Token {
  async getToken(): Promise<TokenResult> {
    return Result.failed(new TechnicalError('Cannot get token value on NullToken'));
  }
}
